import { Close } from '@mui/icons-material';
import { Button, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import useCreationPanelStyles from './CreationPanel.styles';

interface Props {
	onClose(): void;
	onSave(): void;
	saveDisabled?: boolean;
	title: string;
	width?: number | string;
}

const CreationPanel: React.FC<React.PropsWithChildren<Props>> = ({
	children,
	onClose,
	onSave,
	saveDisabled = false,
	title,
	width = 522,
}) => {
	// States
	const [otherHeight, setOtherHeight] = useState<number>(0);

	// Hooks
	const classes = useCreationPanelStyles();

	// Effects
	useEffect(() => {
		function keydownListener(e: globalThis.KeyboardEvent): void {
			if (e.key === 'Escape') {
				onClose();
			}
		}

		document.body.addEventListener('keydown', keydownListener);

		return () => {
			document.body.removeEventListener('keydown', keydownListener);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const headerHeight = document.getElementById('creation-panel-header')?.offsetHeight ?? 0;
		const footerHeight = document.getElementById('creation-panel-footer')?.offsetHeight ?? 0;

		setOtherHeight(headerHeight + footerHeight);
	}, []);

	return (
		<div className={classes.root} id="creation-panel">
			<div className={classes.rootBg} />
			<section className={classes.container} style={{ width }}>
				<header className={classes.headerContainer} id="creation-panel-header">
					<Typography
						color="#003C82"
						fontFamily="Montserrat"
						fontSize={18}
						fontWeight="bold"
					>
						{title}
					</Typography>
					<IconButton onClick={onClose} sx={{ color: '#686868' }}>
						<Close />
					</IconButton>
				</header>
				<div
					className={classes.bodyContainer}
					id="creation-panel-body"
					style={{ maxHeight: `calc(100vh - 120px - ${otherHeight}px)` }}
				>
					{children}
				</div>
				<footer className={classes.footerContainer} id="creation-panel-footer">
					<Button
						className={classes.saveButton}
						disabled={saveDisabled}
						onClick={onSave}
						variant="contained"
					>
						GUARDAR
					</Button>
				</footer>
			</section>
		</div>
	);
};

export default CreationPanel;
